import { QueryResult, useQuery } from '@apollo/client'
import { SubordinateMeetingsQuery, SubordinateMeetingsQueryVariables } from '../../../types'
import { SUBORDINATE_MEETINGS } from '../meeting.graphql'

export default (managerId: number): QueryResult<SubordinateMeetingsQuery, SubordinateMeetingsQueryVariables> => {
  return useQuery<SubordinateMeetingsQuery, SubordinateMeetingsQueryVariables>(SUBORDINATE_MEETINGS, {
    variables: {
      managerId: managerId,
    },
  })
}
